'use client'

import { useSyncExternalStore } from 'react'

/** Niente a cui iscriversi: il valore cambia una volta sola, al passaggio server → client. */
const subscribe = () => () => {}
const onClient = () => true
const onServer = () => false

/**
 * `false` nell'HTML renderizzato dal server, `true` da subito sul client.
 *
 * È il gate per tutto ciò che esiste solo nel browser (Web Share API, clipboard,
 * `document` per un portal, IntersectionObserver): senza, l'HTML del server e la prima
 * passata di idratazione non coinciderebbero.
 *
 * Perché non `useState(false)` + `useEffect(() => setState(true))`, che è la forma che si
 * trova ovunque: quella fa un secondo render di TUTTO il componente subito dopo il primo
 * (`react-hooks/set-state-in-effect` lo segnala per questo). `useSyncExternalStore` con uno
 * snapshot diverso fra server e client dà lo stesso risultato in un render solo, ed è la
 * forma che React indica per i valori che dipendono dall'ambiente.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(subscribe, onClient, onServer)
}
